module.exports = {"createText":"Create Role","pageTitleText":"Role Manage","roleName":"Role Name","status":"Status","action":"Action","downloadSystemCerts":"Download System Certs"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/rolesmanage.json
// module id = SOdz
// module chunks = 3